import * as React from 'react'
import type { SVGProps } from 'react'
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2118 5.06563C11.1649 4.91796 11.0745 4.78792 10.9523 4.69256C10.8302 4.59721 10.6821 4.54098 10.5275 4.53125L7.7431 4.33906L6.71185 1.7375C6.65553 1.59425 6.55752 1.4712 6.43049 1.38429C6.30346 1.29737 6.15326 1.25059 5.99935 1.25C5.84543 1.25059 5.69523 1.29737 5.5682 1.38429C5.44117 1.4712 5.34316 1.59425 5.28685 1.7375L4.23685 4.35312L1.47122 4.53125C1.31677 4.54161 1.16898 4.59807 1.04697 4.69334C0.924961 4.78861 0.834345 4.9183 0.786845 5.06563C0.738068 5.21521 0.735218 5.37598 0.778663 5.52721C0.822109 5.67843 0.909857 5.81317 1.0306 5.91406L3.15872 7.71406L2.52591 10.2031C2.48213 10.3715 2.49 10.5492 2.54852 10.713C2.60704 10.8769 2.71349 11.0193 2.85403 11.1219C2.99045 11.2198 3.15299 11.2748 3.32083 11.2798C3.48868 11.2848 3.6542 11.2396 3.79622 11.15L5.99466 9.75781H6.00403L8.37122 11.2531C8.49265 11.332 8.63422 11.3743 8.77903 11.375C8.89727 11.3741 9.01373 11.346 9.11944 11.2931C9.22516 11.2401 9.31732 11.1636 9.38885 11.0694C9.46037 10.9753 9.50936 10.866 9.53203 10.7499C9.55471 10.6339 9.55048 10.5142 9.51966 10.4L8.84935 7.67656L10.9681 5.91406C11.0888 5.81317 11.1766 5.67843 11.22 5.52721C11.2635 5.37598 11.2606 5.21521 11.2118 5.06563Z"
      fill="white"
    />
  </svg>
)
export default SvgStar
